import React from "react";
import { Link } from "react-router-dom";

export default function RecentBlogBox({ blogdata }) {
  return (
    <>
      <div className="gt-recent-items">
        <div className="gt-recent-thumb">
          <img
            src={blogdata.sort_img}
            alt={blogdata.image_alt}
            title={blogdata.image_title}
          />
        </div>
        <div className="gt-recent-content">
          <h5>
            <Link to={`/blog/${blogdata.slug}`}>{blogdata.title}</Link>
          </h5>
        </div>
      </div>
    </>
  );
}
